<template>
  <div
    class="presentation-logo horizontal layout center"
    :class="{
      'has-custom-logo': $store.state.presentation.logo,
      'stick-to-top': isHideTextShare,
      'is-capturing-content-slide': slideActive.type === 'freestyle' && isCaptureContentSlideThumbnail,
      'pointer-events-none': isChangeLogoDisabled,
      'is-text-dark': !isTextColourLight,
    }"
  >
    <div
      @click="clickChangeLogo()"
      v-hover-intent="{
        onEnter: () => hoverLogo('over'),
        onExit: () => hoverLogo('out')
      }"
      class="logo-body"
      :class="{'is-logo-shown': showLogo}"
    >
      <div v-if="showLogo">
        <div
          class="logo-img-change animate__animated animate__fadeIn"
          v-if="$store.state.presentation.logo"
        >
          <img :src="$store.state.presentation.logo.large" />
        </div>
        <div
          class="logo-img"
          v-if="
            currentUser.plan !== 'white-label' &&
              $store.state.presentation.id &&
              !$store.state.presentation.logo &&
              !$store.state.presentation.notShowAhaSlidesLogo
          "
        >
          <aha-logo
            width="156"
            height="26"
            viewBox="0 0 9600 1602"
            class="img-logo-default"
          />
          <aha-logo
            width="156"
            height="26"
            viewBox="0 0 9600 1602"
            :use-default-color="false"
            class="img-logo-white"
          />
        </div>
      </div>
      <div
        v-if="!showLogo"
        class="no-logo"
      >
        <aha-icon name="image" :class="!isTextColourLight ? 'text-base-90' : 'text-base-0'" />
      </div>
      <PlanUpgradeModal
        :popup="'bottom'"
        :is-show-tooltip="changeLogoUpgrade"
        @outsideEvent="clickOutsideUp"
        :name-feature="'Canvas logo'"
      >
        <template #tooltipcontent>
          <div class="flex items-center justify-start mb-2" style="display: flex">
            <div class="font-bold">
              {{ $i18nPresenter.t('Change logo') }}
            </div>
            <img src="@/assets/images/pro.svg" class="ml-2 cursor-pointer" />
          </div>
          <span>{{ $i18nPresenter.t("This feature is not available in you current plan.") }}</span>
        </template>
      </PlanUpgradeModal>
      <div v-if="isLogoActionsVisible" class="logo-action" v-click-outside="clickOutsideLogoAction">
        <div class="logo-action-item" @click="openModalUploadLogo()">
          <aha-icon name="image" class="text-base-70" />
          <span>{{ $i18nPresenter.t('Change') }}</span>
        </div>
        <div class="logo-action-item" @click.stop="setShowAhaSlidesLogo()">
          <aha-icon name="hide" v-if="notShowAhaSlidesLogo" class="text-base-70" />
          <aha-icon name="unhide" v-else class="text-base-70" />
          <span>{{ !notShowAhaSlidesLogo ? 'Hide' : 'Unhide' }}</span>
        </div>
        <div
          v-if="$store.state.presentation.logo"
          class="logo-action-item"
          @click.stop="resetLogo()"
        >
          <aha-icon
            name="reset"
            width="22"
            height="22"
            viewBox="0 0 18 18"
            class="text-base-70"
          />
          <span>{{ $i18nPresenter.t('Reset') }}</span>
        </div>
      </div>
    </div>
    <CropImage
      :type="uploadType"
      v-if="showCropImage"
      :aspect-ratio="4.45"
      :image-url="imageUrlCrop"
      @hideModal="closeModalCrop"
      @on-cancel="handleCancelCrop"
      @handleCropImageFinished="handleCropImageFinished"
    />
    <UploadImageV2
      type="canvasLogo"
      v-if="modalUploadLogo"
      @hideModal="hideModalUploadLogo"
      @callback="handleUploadImageForm"
      :updateGifInBackground="handleUpdateGifInBackground"
      @selectExistImage="selectExistImage"
    />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import utils from '@/util'
import UploadImageV2 from '@/components/presentations/UploadImage.v2.vue'
import CropImage from '@/components/presentations/CropImage.vue'
import eventCategories from '@/constant/eventCategories'
import Config from '@/config'
import PlanUpgradeModal from '@/components-v2/presentation-editor/editor-header/PlanUpgrade.vue'

export default {
  name: 'CanvasLogo',
  components: {
    UploadImageV2,
    CropImage,
    PlanUpgradeModal,
  },
  data() {
    return {
      changeLogoUpgrade: false,
      changeLogoPopup: false,
      showCropImage: false,
      imageUrlCrop: '',
      uploadType: 'logo',
      modalUploadLogo: false,
      isLogoActionsVisible: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      isCaptureContentSlideThumbnail: (state) => state.isCaptureContentSlideThumbnail,
      isSharingView: (state) => state.sharePresentation,
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
    }),
    ...mapGetters(['isPresenting', 'isBackstage', 'isTextColourLight']),
    isChangeLogoDisabled() {
      return this.isSharingView || this.isPresenting || this.isBackstage
    },
    isHideTextShare() {
      return !!utils.getParamValue('hideText', window.location.href)
    },
    isWhiteLabel() {
      return this.$store.state.plan.group === 'white-label'
    },
    isProPlan() {
      return this.$store.state.plan.group == 'pro'
    },
    showLogo() {
      return !this.presentation.notShowAhaSlidesLogo
    },
    notShowAhaSlidesLogo() {
      return this.presentation.notShowAhaSlidesLogo
    },
  },
  methods: {
    clickChangeLogo() {
      utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Canvas logo > Click')
      if (this.isProPlan || this.isWhiteLabel) {
        this.isLogoActionsVisible = true
        return
      }
      this.changeLogoUpgrade = true
    },
    handleModalUpgradeApply() {
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Feature upgrade',
        'Canvas logo',
      )
      this.changeLogoUpgrade = false
      this.$router.push('/apps/user-plan?redirect=/apps/user-plan')
    },
    handleModalChangeLogoApply() {
      this.changeLogoPopup = false
    },
    handleUploadImageForm(data) {
      this.modalUploadLogo = false
      this.imageUrlCrop = data
      this.showCropImage = true
    },
    setShowAhaSlidesLogo() {
      this.isLogoActionsVisible = false
      this.$store.state.presentation.notShowAhaSlidesLogo = !this.$store.state.presentation.notShowAhaSlidesLogo
      utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, this.$store.state.presentation.notShowAhaSlidesLogo ? 'Canvas logo > Hide logo' : 'Canvas logo > Unhide logo')
      const payload = {
        notShowAhaSlidesLogo: this.$store.state.presentation.notShowAhaSlidesLogo,
      }
      this.$store.dispatch('setSyncPresentation', 1)
      this._updatePresentation(payload)
    },
    _updatePresentation(payload) {
      this.$http.put(Config.api.updatePresentation + this.$route.params.id, payload)
        .then(
          () => this.$store.dispatch('setSyncPresentation', 2),
        ).catch(
          () => this.$store.dispatch('setSyncPresentation', 3),
        )
    },
    closeModalCrop() {
      this.showCropImage = false
    },
    handleCancelCrop() {
      this.showCropImage = false
      this.modalUploadLogo = true
    },
    handleCropImageFinished(data) {
      this._updatePresentationLogo(data.crop)
    },
    resetLogo() {
      utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Canvas logo > Reset logo')
      this.isLogoActionsVisible = false
      this.modalUploadLogo = false
      this.$store.state.presentation.logo = null
      this.$store.state.presentation.notShowAhaSlidesLogo = false
      this.$store.dispatch('updatePresentation', {
        logo: this.$store.state.presentation.logo,
      })
      const payload = {
        logo: this.$store.state.presentation.logo,
        notShowAhaSlidesLogo: this.$store.state.presentation.notShowAhaSlidesLogo,
      }
      this.$store.dispatch('setSyncPresentation', 1)
      this._updatePresentation(payload)
    },
    openModalUploadLogo() {
      utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Canvas logo > Change logo')
      this.isLogoActionsVisible = false
      this.modalUploadLogo = true
    },
    hideModalUploadLogo() {
      this.modalUploadLogo = false
    },
    clickOutsideUp() {
      this.changeLogoUpgrade = false
    },
    _hideModalUploadImage() {
      this.modalUploadLogo = false
    },
    hoverLogo(hover) {
      if (hover === 'over') {
        utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Canvas logo > Hover')
      }
    },
    clickOutsideLogoAction() {
      this.isLogoActionsVisible = false
    },
    async handleUpdateGifInBackground(data) {
      const { imageUrl } = data
      const uploadLinkResponse = await this.handleUploadLinkImage(imageUrl)
      this.modalUploadLogo = false
      this._updatePresentationLogo(uploadLinkResponse.body.file)
      this.$store.dispatch('updatePresentation', {
        notShowAhaSlidesLogo: false,
      })
      this._updatePresentation({ notShowAhaSlidesLogo: false })
    },

    async handleUploadLinkImage(imageUrl) {
      return this.$http.post(Config.api.uploadLink, {
        image: imageUrl,
      })
    },
    _updatePresentationLogo(url) {
      this.$http
        .put(Config.api.updatePresentation + this.$store.state.presentation.id, {
          logo: url,
        })
        // eslint-disable-next-line promise/always-return
        .then(() => {
          const logo = {
            thumbnail: url,
            large: url,
            name: url,
          }
          this.$store.state.presentation.logo = logo
          this.closeModalCrop()
          this.$store.dispatch('updatePresentation', {
            notShowAhaSlidesLogo: false,
          })
          this._updatePresentation({ notShowAhaSlidesLogo: false })
        }).catch(() => {})
    },
    async selectExistImage(obj) {
      this.modalUploadLogo = false
      this._updatePresentationLogo(obj.origin)
      this.$store.dispatch('updatePresentation', {
        notShowAhaSlidesLogo: false,
      })
      this._updatePresentation({ notShowAhaSlidesLogo: false })
    },
  },
}
</script>

<style lang="scss" scoped>
.presentation-logo {
  width: auto;
  position: absolute;
  right: 10px;
  z-index: 127;
  height: 58px;
  cursor: pointer;
  &:hover {
    .logo-body {
      background: rgba(255, 255, 255, 0.2);
      &.is-logo-shown {
        border: 1px solid #348EF6; // primary-90
      }
    }
    &.is-text-dark .logo-body {
      background: rgba(0, 0, 0, 0.05);
    }
    .no-logo {
      opacity: 100;
    }
  }
  &.is-text-dark {
    .logo-img {
      .img-logo-white {
        display: none;
      }
      .img-logo-default {
        display: block;
      }
    }
    .no-logo {
      background: rgba(0,0,0,0.05);
    }
  }
  .logo-body {
    border: 1px solid transparent;
    position: relative;
  }
  .logo-img {
    .img-logo-white {
      display: block;
    }
    .img-logo-default {
      display: none;
    }
  }
  .logo-img {
    .img-logo-white,
    .img-logo-default {
      width: auto;
      max-height: 58px; //equal to top-header's height
    }
  }
  &.is-capturing-content-slide {
    display: none;
  }

  .logo-img-change img {
    width: auto;
    max-width: 178px;
    max-height: 40px; //equal to top-header's height
  }

  // @media (max-width: 768px) and (orientation: landscape) {
  //   top: 50px;
  // }

  &.stick-to-top {
    top: 0 !important;
  }

  &.has-custom-logo {
    border: 1px solid transparent;
    .logo-img-change img {
      max-width: 178px;
      max-height: 40px;
      border-radius: 6px;
    }

    // @media (max-width: 768px) and (orientation: landscape) {
    //   top: 50px;
    // }
  }
}
.change-logo-header {
  @apply flex justify-between border-b border-base-30 pl-4 pr-4 pb-4 relative;
  font-family: 'Nunito', sans-serif;
  .title {
    @apply text-base-100 font-bold text-base;
  }

  i {
    @apply text-base-70;
  }

  .pb-3 {
    padding-bottom: 0 !important;
  }
}

.change-logo-upgrade {
  @apply bg-secondary-100 absolute min-w-60 p-3 rounded z-50 right-0 top-14;
  font-family: 'Nunito', sans-serif;
  div,
  span {
    @apply text-base-0 text-sm;
  }

  div {
    @apply font-bold;
  }

  span {
    @apply font-normal mt-1;
  }

  .flex {
    display: flex;
  }
}

.no-logo, .logo-body {
  width: 178px;
  height: 40px;
  border-radius: 4px;
  color: #ffffff;
  @apply flex justify-center items-center;
}
.no-logo {
  background: rgba(255, 255, 255, 0.2);
  @apply opacity-0;
  transition: 0.1s ease;
}

.change-logo-content {
  height: 350px;
  padding: 0 32px;

  & ::v-deep .aha-form-file {
    height: 290px;
  }

  .change-logo-body {
    padding-top: 24px;

    label {
      margin-bottom: 0 !important;
    }

    .change-logo-preview {
      height: 350px;
      @apply flex flex-col;

      img {
        @apply flex-grow;
      }
    }
  }
}

.logo-action {
  @apply right-0 top-14 absolute bg-base-0 rounded-md border-base-30 border shadow-dropdown;
  // box-shadow: 0 0 #0000, 0 0 #0000, 1;
  width: 178px;
  font-family: 'Nunito', sans-serif;
  .logo-action-item {
    @apply flex items-center justify-start p-2 space-x-2 text-base-90;
    font-size: 17px;
    &:first-child{
      @apply rounded-t-md;
    }
    &:last-of-type{
      @apply rounded-b-md;
    }
    &:hover{
      --tw-bg-opacity: 1;
      background-color: rgba(245,245,245,var(--tw-bg-opacity));
    }
  }
    &:not(:nth-of-type(3)){
      @apply border-b border-base-30;
    }
  }
.logo-hover{
  display: none;
  width: 178px;
}
.duc-test {
  .cta-upgrade{
    top: 3rem;
  }
}
</style>
